var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrCrossSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 5.99994C17.8125 5.81247 17.5582 5.70715 17.2931 5.70715C17.0279 5.70715 16.7736 5.81247 16.5861 5.99994L12.0001 10.5859L7.41406 5.99994C7.22653 5.81247 6.97223 5.70715 6.70706 5.70715C6.4419 5.70715 6.18759 5.81247 6.00006 5.99994C5.81259 6.18747 5.70728 6.44178 5.70728 6.70694C5.70728 6.9721 5.81259 7.22641 6.00006 7.41394L10.5861 11.9999L6.00006 16.5859C5.81259 16.7735 5.70728 17.0278 5.70728 17.2929C5.70728 17.5581 5.81259 17.8124 6.00006 17.9999C6.18759 18.1874 6.4419 18.2927 6.70706 18.2927C6.97223 18.2927 7.22653 18.1874 7.41406 17.9999L12.0001 13.4139L16.5861 17.9999C16.7736 18.1874 17.0279 18.2927 17.2931 18.2927C17.5582 18.2927 17.8125 18.1874 18.0001 17.9999C18.1875 17.8124 18.2928 17.5581 18.2928 17.2929C18.2928 17.0278 18.1875 16.7735 18.0001 16.5859L13.4141 11.9999L18.0001 7.41394C18.1875 7.22641 18.2928 6.9721 18.2928 6.70694C18.2928 6.44178 18.1875 6.18747 18.0001 5.99994Z",
    fill: "#374151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCrossSmall);
export default __webpack_public_path__ + "static/media/fi-rr-cross-small.bba4c1414fa4c340a382e3aa0c93465c.svg";
export { ForwardRef as ReactComponent };